import Resource from "./resource";
import {SensitiveValue} from "./propertyValueResource";

export enum FeedType {
    Nuget = "NuGet",
    Docker = "Docker",
    Maven = "Maven"
}

export interface DockerFeedResource extends Resource {
    FeedType: FeedType.Docker;
    ApiVersion?: any;
    RegistryPath: string;
    Name: string;
    FeedUri: string;
    Username?: any;
    Password?: any;
    LastModifiedOn?: any;
    LastModifiedBy?: any;
}

export interface RetryFeed extends Resource {
    DownloadAttempts: number;
    DownloadRetryBackoffSeconds: number;
}

export interface NugetFeedResource extends RetryFeed {
    FeedType: FeedType.Nuget;
    EnhancedMode: boolean;
    Name: string;
    FeedUri: string;
    Username?: string;
    Password?: SensitiveValue;
}

export interface MavenFeedResource extends RetryFeed {
    FeedType: FeedType.Maven;
    Name: string;
    FeedUri: string;
    Username?: string;
    Password?: SensitiveValue;
}

type FeedResource = NugetFeedResource | DockerFeedResource | MavenFeedResource;

export default FeedResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/feedResource.ts